import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María G.', 'Carlos R.', 'Ana L.', 'Valentina P.', 'Diego M.', 'Gabriela S.', 'Alejandro T.', 'Camila H.'];
const locations = ['Ciudad de México', 'Bogotá', 'Buenos Aires', 'Santiago', 'Lima', 'Madrid', 'Miami', 'Monterrey'];
const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 3 horas'];
export function PopNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    location: '',
    time: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 15000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setNotification({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one between 20-45 seconds
      const nextDelay = Math.floor(Math.random() * 25000) + 20000;
      setTimeout(showRandomNotification, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-310">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: '-50%'
    }} animate={{
      opacity: 1,
      y: 0,
      x: '-50%'
    }} exit={{
      opacity: 0,
      y: 20,
      x: '-50%'
    }} className="fixed bottom-6 left-1/2 md:left-6 md:translate-x-0 z-[9999] w-[90%] max-w-[320px] bg-white rounded-2xl p-3 shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[rgba(183,110,121,0.15)] flex items-center gap-3 font-sans" style={{
      transform: 'translateX(-50%)'
    }} data-id="element-311">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#B76E79] to-[#C9A96E] flex items-center justify-center text-white text-lg flex-shrink-0" data-id="element-312">
            ✓
          </div>
          <div className="flex-1 min-w-0" data-id="element-313">
            <p className="m-0 text-sm text-[#3D2B1F] leading-tight truncate" data-id="element-314">
              <strong data-id="element-315">{notification.name}</strong> de {notification.location}
            </p>
            <p className="m-0 text-sm text-[#B76E79] font-bold leading-tight mt-0.5" data-id="element-316">
              Compró el Protocolo B.E.BE
            </p>
            <p className="m-0 text-xs text-gray-400 mt-1" data-id="element-317">
              {notification.time}
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 bg-transparent border-none cursor-pointer p-1" aria-label="Cerrar notificación" data-id="element-318">
            ✕
          </button>
        </motion.div>}
    </AnimatePresence>;
}